import { useCallback, useState } from "react";

import FullScreenModal from "ds/components/FullScreenModal";
import { showSimpleLeaveConfirmation } from "ds/components/LeaveConfirmationModal/Simple";
import useTypedFlags from "hooks/useTypedFlags";

import useCloseFullScreenModal from "../useCloseFullScreenModal";
import VCSIntegrationsManageBitbucketCloudForm from "./Form";
import VCSIntegrationsManageBitbucketCloudFormV2 from "./FormNew";

const VCSIntegrationsManageBitbucketCloud = () => {
  const { bitbucketApiTokenSupport } = useTypedFlags();
  const [isDirty, setIsDirty] = useState(false);

  const { handleOnClose } = useCloseFullScreenModal();

  const modalCloseClickHandler = useCallback(async () => {
    if (isDirty) {
      await showSimpleLeaveConfirmation();
    }

    handleOnClose();
  }, [handleOnClose, isDirty]);

  const toggleIsDirty = useCallback((value: boolean) => {
    setIsDirty(value);
  }, []);

  return (
    <FullScreenModal title="Set up Bitbucket Cloud integration" onClose={modalCloseClickHandler}>
      {bitbucketApiTokenSupport ? (
        <VCSIntegrationsManageBitbucketCloudFormV2 onIsDirtyChange={toggleIsDirty} />
      ) : (
        <VCSIntegrationsManageBitbucketCloudForm onIsDirtyChange={toggleIsDirty} />
      )}
    </FullScreenModal>
  );
};

export default VCSIntegrationsManageBitbucketCloud;
